export default __webpack_public_path__ + "static/media/01.e03929a2.svg";